// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2jyD9","productName":"Table_productName__2P7Fo"};